import { render, staticRenderFns } from "./AgeStructure.vue?vue&type=template&id=3d1a919c&"
import script from "./AgeStructure.vue?vue&type=script&lang=js&"
export * from "./AgeStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports